/**
 * @fileoverview POST handler for the "/engagement/feature_flag_rollout_upsert" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { engagementFeatureFlagRolloutUpsertCacheKeys } from "./constants";
import type {
  PostEngagementFeatureFlagRolloutUpsertProps,
  EngagementFeatureFlagRolloutUpsertResult,
  FeatureFlagUpsertError,
} from "./types";

export const postEngagementFeatureFlagRolloutUpsert = reactQueryMutationAdapter(
  engagementFeatureFlagRolloutUpsertCacheKeys,
  createMutationFetcherFunctionWithShadowError<FeatureFlagUpsertError>()(
    (props: PostEngagementFeatureFlagRolloutUpsertProps): Promise<EngagementFeatureFlagRolloutUpsertResult> => {
      return fetch(
        "/engagement/feature_flag_rollout_upsert",
        "POST",
        props,
        {},
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
